import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import { toggleDrawer, toggleDrawerContent, logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { createCaseActions } from '@codametrix/ui-common';

const reducer = createReducer(InitialState.createCase, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.createCase }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.createCase }));

  builder.addCase(toggleDrawerContent, (state, action) => ({
    ...state,
    isOpen: action.payload
  }));

  builder.addCase(toggleDrawer, (state, action) => ({
    ...state,
    isDrawerOpen: action.payload
  }));

  builder.addCase(createCaseActions.navigateCreateCase.pending, (state, action) => ({
    ...state,
    activeCaseRun: action.meta.arg,
    isDrawerOpen: true
  }));

  builder.addCase(createCaseActions.navigateCreateCase.fulfilled, state => ({
    ...state,
    isOpen: true
  }));

  builder.addCase(createCaseActions.fetchNotesSpecialty.pending, state => ({
    ...state,
    notesSpecialty: [],
    notesSpecialtyLoading: true
  }));

  builder.addCase(createCaseActions.fetchNotesSpecialty.fulfilled, (state, action) => ({
    ...state,
    notesSpecialty: action.payload?.rowValues ?? [],
    notesSpecialtyLoading: false
  }));
});

export default reducer;
